import { Components, Theme } from '@mui/material/styles';

export const muiContainerOverride: Components<Theme>['MuiContainer'] = {
  defaultProps: {
    maxWidth: 'xl',
    fixed: false,
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const disableGutters = ownerState?.disableGutters;

      return {
        paddingLeft: disableGutters ? 0 : theme.spacing(14),
        paddingRight: disableGutters ? 0 : theme.spacing(14),
        marginLeft: 'auto',
        marginRight: 'auto',

        [theme.breakpoints.up('sm')]: {
          paddingLeft: disableGutters ? 0 : theme.spacing(20),
          paddingRight: disableGutters ? 0 : theme.spacing(20),
        },
        [theme.breakpoints.up('md')]: {
          paddingLeft: disableGutters ? 0 : theme.spacing(32),
          paddingRight: disableGutters ? 0 : theme.spacing(32),
        },
        [theme.breakpoints.up('lg')]: {
          paddingLeft: disableGutters ? 0 : theme.spacing(58),
          paddingRight: disableGutters ? 0 : theme.spacing(58),
        },
        [theme.breakpoints.up('xl')]: {
          paddingLeft: disableGutters ? 0 : theme.spacing(60),
          paddingRight: disableGutters ? 0 : theme.spacing(60),
        },
      };
    },
  },
};
